import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=4aadc391&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22413/203/Snaply5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aadc391')) {
      api.createRecord('4aadc391', component.options)
    } else {
      api.reload('4aadc391', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=4aadc391&", function () {
      api.rerender('4aadc391', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/snaply/Carousel.vue"
export default component.exports